import { combineReducers } from '@reduxjs/toolkit';
import { dayOffReducer } from './dayOff';
import { dayOffSelectedReducer } from './dayOffSelection';

const reducer = combineReducers({ dayOff: dayOffReducer, dayOffSelected: dayOffSelectedReducer });
export default reducer;
